/* eslint-disable @typescript-eslint/indent */
import Toaster from '@/components/common/Toaster';
import { IOrderDetailsResponse, IOrderDetails } from '@/interfaces/checkout';
import { IError } from '@/interfaces/common';
import { domainName, razorPayKey } from '@/utils/common/env.constants';
import { Button, Typography } from '@pwskills/rachnaui';
import { useUTMParameters } from '@pwskills/rachnaui/hooks';
import { randomId } from '@pwskills/rachnaui/utils';
import { useRouter } from 'next/router';
import { useCallback, useEffect, useState } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { ArrowForward } from '@pwskills/rachnaui/Icons';
// import { LoginType } from '@/GlobalEnums/enums';
// import { useLoginFlowContext } from '@/context/LoginFlowContext';
import MasterClassDesc from '@/api/masterclassDescription';
import useZoomClass from '@/hooks/useZoomClass';
import { ZOOM_CLASS_TYPES } from '@/utils/aboutUs/zoomClass';
import useZoomClassErrorHandler from '@/hooks/useZoomClassErrorHandler';
import { MasterClassCourseType } from '@/components/PostLoginOnboarding/Utilities/enums';
import { MASTERCLASS_REGISTRATION_AND_CLASS_STATUS } from '@/utils/common/masterclassDescription';
import MasterClassApi from '@/api/masterclass';
import getMasterclassPowerBatchPath from '@/utils/masterclass/joinPath';
import { buildPowerBatchRedirectPath } from '@/components/LectureTrack/utils.function';
import moEvent from '@/utils/moEngage';
import {
  LeadCaptureEnquiryType,
  LeadCaptureType,
  LeadType,
  ModalType,
} from '@/interfaces/leadCapture.enum';
import {
  addToGoogleCalender,
  getDateAndTime,
  getInstructorNameAndCompany,
  MASTERCLASS_TYPES,
} from '@/utils/masterclass/masterclass';
import OnboardingLeadForm from '@/components/common/OnboardingLeadForm';
import useMasterclassDescriptionStore from '@/store/MasterClassDescription/useMasterclasDescriptionStore';
import useUserDetails from '@/store/userDetails';
import { IMasterclassDescription } from '@/interfaces/masterclassDescription';
import { GAevent } from '@/utils/firebase.utils';
import { usePWAuthWebSDK } from '@/hooks/usePWAuthWebSDK';
import { domainNameEnums, saasDomains } from '@/utils/Domain';
import { saasDomainprefixUrl, skillsDomainprefixUrl } from '@/utils/Configuration/utils';
import { AuthEnums } from '@/GlobalEnums/enums';
import LSQApi from '@/api/lsq';
import { buildLSQProceedToBuyPayload } from '@/utils/lsq/lsqHelpers';
import LoadingModal from './loadingModal';
import PaymentFailureModal from './paymentFailure';
import PaymentSuccessModal from './paymentSuccess';

const RegistrationFlow = ({
  masterclassId,
  masterclassSlug,
  masterclassName,
  isUserRegistered,
  isFixed,
  registrationStatus,
  pricing,
  setUserRegistered,
  isDashBoard = false,
}: {
  masterclassId: string;
  masterclassName: string;
  isUserRegistered: boolean;
  isFixed?: boolean;
  registrationStatus: string;
  pricing: any;
  setUserRegistered: any;
  masterclassSlug: string;
  isDashBoard?: boolean;
}) => {
  const [errorPop, setErrorPop] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [openSuccessModal, setOpenSuccessModal] = useState<boolean>(false);
  const [openFailureModal, setOpenFailureModal] = useState<boolean>(false);
  const [isUserLoggedInFromPackage, setIsUserLoggedInFromPackage] = useState<boolean>(false);
  const [serverError, setServerError] = useState<{
    status: boolean;
    message: string;
  }>({ status: false, message: '' });
  // const { user, isLoggedIn } = useContext(UserDetailsContext);
  const { userDetails: user, userIsLoggedIn: isLoggedIn, setUserDetails } = useUserDetails();
  const router = useRouter();
  // const isDashBoard = router?.pathname.includes('/dashboard');
  const { showRazorpayPopup, type } = router.query;
  const utmQuery = useUTMParameters();
  // const { triggerFlow, setNextRoute } = useLoginFlowContext();
  const prefixUrl = saasDomains.includes(domainName as domainNameEnums)
    ? saasDomainprefixUrl
    : skillsDomainprefixUrl;
  const [openModal, setOpenModal] = useState(false);

  const { errToaster, setErrToaster, errMessage, handleError } = useZoomClassErrorHandler();

  const checkIfPresenceAlreadyFilled = () => {
    if (saasDomains.includes(domainName as domainNameEnums)) return true;
    if (
      user?.profileId?.userPreferences?.interestedDomain?.title &&
      user?.profileId?.userPreferences?.interestedDomain?.title !== ''
    ) {
      return true;
    }
    return false;
  };

  const masterclassDetails = useMasterclassDescriptionStore(
    (state: { masterclassDetails: IMasterclassDescription }) => state.masterclassDetails
  );

  const { getZoomKeysDetails } = useZoomClass({
    courseId: masterclassId as string,
    courseName: masterclassName as string,
    handleError,
    zoomClassType: ZOOM_CLASS_TYPES.MASTER_CLASS,
    masterclassSlug,
  });

  const { executeRecaptcha } = useGoogleReCaptcha();

  const handleReCaptchaVerify = useCallback(async () => {
    if (!executeRecaptcha) {
      return '';
    }

    const token = await executeRecaptcha(randomId());
    return token;
  }, [executeRecaptcha]);

  const { initApp } = usePWAuthWebSDK({
    sdkProps: {
      themeFor: 'skills',
      onGoogleSignIn: () => {
        // your logic
      },
      googleClientId: process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID || '',
      cameFrom: AuthEnums.BLOG,
      ctaName: AuthEnums.LOGIN,
      formLocation: 'masterclass_description',
    },
    onAuthSuccessCallBack: () => {
      setIsUserLoggedInFromPackage(true);
    },
  });

  const sendGAevent = (source: string) => {
    const GAEventData = {
      source,
      ...utmQuery,
    };
    GAevent('sk_login_page_visit', GAEventData);
  };

  const handleClickWithRedirect = (redirectUrl: string) => {
    if (isLoggedIn) {
      router.push(redirectUrl);
      return;
    }
    initApp(redirectUrl);
    sendGAevent('Masterclass Registration');
  };

  const removeIsShowPopupFromRouter = () => {
    if (router.query.showRazorpayPopup) {
      // Construct the new query object without 'showRazorpayPopup'
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { showRazorpayPopup: showRazorpayPopupQuery, ...queryWithoutPopup } = router.query;

      // Construct the new URL with the remaining query parameters
      const newUrl = {
        pathname: router.pathname,
        query: queryWithoutPopup,
      };

      // Replace the URL without refreshing the page
      router.replace(newUrl, undefined, { shallow: true });
    }
  };

  const isDisabled = () => {
    switch (registrationStatus) {
      case MASTERCLASS_REGISTRATION_AND_CLASS_STATUS.OPEN:
        if (isUserRegistered) {
          return true;
        }
        return false;
      case MASTERCLASS_REGISTRATION_AND_CLASS_STATUS.CLASS_STARTED:
        if (!isUserRegistered) {
          return true;
        }
        return false;
      case MASTERCLASS_REGISTRATION_AND_CLASS_STATUS.CLASS_ENDED:
        return false;
      default:
        return false;
    }
  };

  const isClassStarted = () => {
    return registrationStatus === MASTERCLASS_REGISTRATION_AND_CLASS_STATUS.CLASS_STARTED;
  };
  const getButtonText = () => {
    return isUserRegistered
      ? isClassStarted()
        ? 'Join Now'
        : 'Registered'
      : isClassStarted()
      ? 'Registration Closed'
      : 'Register Now';
  };

  const createCourseOrder = async (isFreeCheckout = false) => {
    const token = await handleReCaptchaVerify();
    const payload = {
      'g-recaptcha-response': token,
      ...utmQuery,
      coupon: '',
      sourceType: `${type ? 'marketing_page' : 'website_landing_page'}`,
    };
    let orderResponse = null;

    await MasterClassDesc.registerToMasterclass(payload, masterclassId, isFreeCheckout)
      .then((response: any) => {
        setErrorPop(false);
        orderResponse = response.data;
      })
      .catch((err) => {
        setServerError({
          status: false,
          message: err?.error || 'Something went wrong',
        });
        setErrorPop(true);
        setLoading(false);
      });
    return orderResponse;
  };

  const initializeRazorpay = () => {
    return new Promise((resolve) => {
      const scriptElement = document.createElement('script');
      scriptElement.type = 'text/javascript';
      scriptElement.async = true;
      scriptElement.src = `https://checkout.razorpay.com/${prefixUrl}/checkout.js`;

      scriptElement.addEventListener('load', () => {
        resolve('success');
      });
      document.body.appendChild(scriptElement);
    });
  };

  const sendPaymentGAEvent = (status: string, reason?: string) => {
    const GAEventData = {
      user_id: user?._id,
      user_type: isLoggedIn ? 'loggedin' : 'not_loggedin',
      page_name: 'course_description_page',
      page_ref: router.query.page_ref,
      category_id: masterclassDetails?.cohortId?._id || '',
      category_name: masterclassDetails?.categoryId?.parent?.title || '',
      course_id: masterclassDetails?._id,
      course_name: masterclassDetails?.title,
      course_type: 'masterclass',
      total_amount: pricing.actualPrice,
      discount: pricing.discount,
      utm_source: utmQuery?.utm_source,
      utm_medium: utmQuery?.utm_medium,
      utm_campaign: utmQuery?.utm_campaign,
    };

    if (status === 'success') {
      GAevent('sk_transaction_success', GAEventData);
    } else {
      GAevent('sk_transaction_fail', { ...GAEventData, fail_reason: reason });
    }
  };

  const handleStandardCheckout = async () => {
    setLoading(true);
    try {
      const lsqPayload = buildLSQProceedToBuyPayload({
        userId: user?.id,
        name: `${user?.firstName || ''} ${user?.lastName || ''}`.trim(),
        mobile: user?.phoneNumber || '',
        email: user?.email || '',
        utmSource: utmQuery?.utm_source,
        utmMedium: utmQuery?.utm_medium,
        utmCampaign: utmQuery?.utm_campaign,
        batchId: masterclassDetails?._id,
        batchName: masterclassDetails?.title,
        categoryName: masterclassDetails?.categoryId?.parent?.title || '',
        productType: 'Masterclass',
      });
      LSQApi.sendLead(lsqPayload);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('LSQ Proceed to Buy event failed:', error);
    }
    const success = await initializeRazorpay();
    if (success) {
      createCourseOrder()
        .then((response: IOrderDetails | null) => {
          // console.log('response--', response);
          if (response) {
            const data = {
              key: razorPayKey,
              amount: response?.amount,
              currency: response?.currency,
              order_id: response?.orderId,
              name: `Physics Wallah Ltd.`,
              prefill: {
                name: `${user?.firstName} ${user?.lastName}`,
                email: user?.email,
                contact: `${user?.isdCode}${user?.phoneNumber}`,
              },
              handler: () => {
                // set userType as free/paid to update status of upcoming events
                if (pricing.isCourseFree) {
                  setUserDetails({ ...user, userType: MasterClassCourseType.FREE });
                } else {
                  setUserDetails({ ...user, userType: MasterClassCourseType.PAID });
                }
                // setOpenSuccessModal(true);
                if (isLoggedIn && !checkIfPresenceAlreadyFilled()) {
                  setOpenModal(true);
                } else {
                  setOpenSuccessModal(true);
                }
                setUserRegistered(true);
                sendPaymentGAEvent('success');
                document.body.classList.add('scroll-y');
              },
              modal: {
                ondismiss() {
                  document.body.classList.add('scroll-y');
                },
              },
            };

            const razorpay = new window.Razorpay(data);
            razorpay?.open();
            setLoading(false);

            razorpay?.on('payment.success', () => {
              // scroll was paused after closing razor pay popup
              document.body.classList.add('scroll-y');
            });

            razorpay?.on('payment.error', (err: any) => {
              sendPaymentGAEvent('failure', err.error.description);
              razorpay?.close();

              const razorpayContainer = document.querySelectorAll('.razorpay-container');
              razorpayContainer.forEach((container) => {
                container.remove();
              });
              // scroll was paused after closing razor pay popup
              document.body.classList.add('scroll-y');
              setOpenFailureModal(true);
            });
          }
        })
        .catch((err: IError) => {
          // console.log('err--', err);
          setServerError({
            status: false,
            message: err?.error || 'Something went wrong',
          });
          return setErrorPop(true);
        });
    }
  };

  const sendGAEvent = (action: string) => {
    const actionText = action.toLowerCase().replaceAll(' ', '_');
    const GAEventData = {
      user_id: user?._id,
      user_type: isLoggedIn ? 'logged_in' : 'logged_out',
      action: actionText,
      page_name: 'course_description_page',
      page_ref: router.query.page_ref,
      source: 'strip',
      user_category: user?.userType || '',
      category_id: masterclassDetails?.cohortId?._id || '',
      category_name: masterclassDetails?.categoryId?.parent?.title || '',
      course_id: masterclassDetails?._id,
      course_name: masterclassDetails?.title,
      course_type: 'masterclass',
      utm_source: utmQuery?.utm_source,
      utm_medium: utmQuery?.utm_medium,
      utm_campaign: utmQuery?.utm_campaign,
    };

    GAevent('sk_course_descrip_action', GAEventData);
  };

  const moEngageEventTrigger = (event: string) => {
    if (router?.isReady && user?._id && isLoggedIn) {
      const moEngageData = {
        user_id: user?._id || '',
        username: `${user?.firstName} ${user?.lastName}` || '',
        phone_number: user?.phoneNumber || '',
        user_type: isLoggedIn ? 'loggedin' : 'not_loggedin',
        masterclass_name: masterclassDetails?.title,
        masterclass_date: getDateAndTime(masterclassDetails).date,
        masterclass_time: `${getDateAndTime(masterclassDetails).date}, ${
          getDateAndTime(masterclassDetails).time
        }`,
        masterclass_joining_link: masterclassDetails?.liveVideoLink,
        category: masterclassDetails?.categoryId?.parent?.title || '',
        masterclass_id: masterclassId,
        community_link: masterclassDetails?.communityLink,
        source:
          type === MASTERCLASS_TYPES.MARKETING ? 'marketing landing page' : 'website landing page',
        calendar_url: addToGoogleCalender(
          masterclassDetails.slug,
          masterclassId,
          masterclassDetails.title,
          masterclassDetails.masterclassTimings
        ),
        ...(user?.verified && user?.email && { email: user.email }),
        ...(event === 'masterclass_register_now_cta' && {
          masterclass_type: pricing.isCourseFree ? 'Free' : 'Paid',
          speaker_name: getInstructorNameAndCompany(masterclassDetails).instructorName || '',
          speaker_company: getInstructorNameAndCompany(masterclassDetails).pastCompanies || '',
          speaker_background:
            getInstructorNameAndCompany(masterclassDetails).instructorDescription || '',
          price: masterclassDetails?.pricing?.IN || '',
          discount: pricing.discount ?? 0,
        }),
      };

      moEvent(event, moEngageData);
    }
  };

  const handleGetCourseDetails = async () => {
    sendGAEvent(getButtonText() as string);
    if (!isUserRegistered) {
      setLoading(true);
      if (isLoggedIn || isUserLoggedInFromPackage) {
        if (pricing) {
          if (pricing.isCourseFree) {
            createCourseOrder(pricing.isCourseFree)
              .then((resp: IOrderDetailsResponse | null) => {
                if (resp) {
                  if (!checkIfPresenceAlreadyFilled()) {
                    setOpenModal(true);
                  } else {
                    setOpenSuccessModal(true);
                  }
                  // setOpenSuccessModal(true);
                  setUserRegistered(true);
                  sendPaymentGAEvent('success');
                }
              })
              .catch((err) => {
                setErrorPop(true);
                // console.log('err--', err);
                setServerError({
                  status: false,
                  message: err?.error || 'Something went wrong',
                });
                sendPaymentGAEvent('failure', err?.error);
              })
              .finally(() => {
                setLoading(false);
              });
          } else {
            handleStandardCheckout();
          }
          moEngageEventTrigger('masterclass_register_now_cta');
        }
      } else {
        setLoading(false);
        handleClickWithRedirect(`/masterclass/${masterclassSlug}?showRazorpayPopup=true`);
      }
    } else if (
      isUserRegistered &&
      MASTERCLASS_REGISTRATION_AND_CLASS_STATUS.CLASS_STARTED === registrationStatus
    ) {
      moEngageEventTrigger('masterclass_join_now_cta');
      MasterClassApi.generateCertificate(masterclassId);
      const powerBatchPath = await getMasterclassPowerBatchPath({
        lessonCourseId: masterclassDetails?.lessonCourseId,
        lessonId: masterclassDetails?.lessonId,
      });
      if (powerBatchPath) {
        router.push(powerBatchPath);
        return;
      }
      if (masterclassDetails?.liveVideoLink?.includes('zoom')) {
        await getZoomKeysDetails();
        return;
      }
      const redirectPath = buildPowerBatchRedirectPath(masterclassDetails?.liveVideoLink);
      if (redirectPath) {
        router.push(redirectPath);
      } else {
        handleError('Unable to open live class. Please try again.');
      }
    }
  };

  // useEffect(() => {
  //   // if (isOnboardingFormCompleted === 'completed') {
  //   //   setOpenModal(false);
  //     setOpenSuccessModal(true);
  //   // }
  // }, [router?.isReady, isLoggedIn]);

  useEffect(() => {
    if (showRazorpayPopup && router.isReady && masterclassId) {
      removeIsShowPopupFromRouter();
      handleGetCourseDetails();
    }
  }, [showRazorpayPopup, router.isReady, masterclassId]);

  const handleRetry = () => {
    handleGetCourseDetails();
  };
  return (
    <div className={`${isDashBoard ? 'w-1/2' : ''}`}>
      {errorPop ? (
        <Toaster
          open={errorPop}
          setOpen={setErrorPop}
          text={serverError?.message}
          variant={serverError?.status ? 'success' : 'error'}
        />
      ) : null}
      <Button
        size="medium"
        endIcon={isUserRegistered || isClassStarted() || isDashBoard ? '' : <ArrowForward />}
        className={
          isDashBoard
            ? `w-[201px] h-[38px] whitespace-nowrap  rounded  ${
                isUserRegistered ? 'bg-green-200 hover:bg-green-200' : ''
              } `
            : ` ${
                isFixed ? ' w-[calc(100%-16px)] ' : 'relative  w-full '
              } whitespace-nowrap  rounded !w-full ${
                isUserRegistered ? 'bg-green-200 hover:bg-green-200' : ''
              } `
        }
        disabled={isDisabled()}
        onClick={() => {
          handleGetCourseDetails();
        }}
      >
        {isDashBoard ? (
          <Typography component="body-small" className="text-white">
            {getButtonText()}
          </Typography>
        ) : (
          getButtonText()
        )}
      </Button>
      {openModal && (
        <OnboardingLeadForm
          type={LeadType.ONBOARDING}
          modalType={ModalType.ONBOARDING}
          modalOpen={openModal}
          setModalOpen={setOpenModal}
          enquiryTypeNPF={LeadCaptureEnquiryType.MASTERCLASS_REGISTRATION}
          enquiryType={LeadCaptureEnquiryType.MASTERCLASS_REGISTRATION}
          pageName="masterclass_description"
          leadCaptureType={LeadCaptureType.MODAL}
          buttonText=""
          msgLineOne=""
          onSuccessCallback={() => {
            setOpenSuccessModal(true);
          }}
        />
      )}
      {openSuccessModal && (
        <PaymentSuccessModal open={openSuccessModal} setOpen={setOpenSuccessModal} />
      )}
      {openFailureModal && (
        <PaymentFailureModal
          open={openFailureModal}
          setOpen={setOpenFailureModal}
          handleRetry={handleRetry}
        />
      )}
      {loading && <LoadingModal open={loading} setOpen={setLoading} />}
      {errToaster && (
        <Toaster open={errToaster} setOpen={setErrToaster} text={errMessage} variant="error" />
      )}
    </div>
  );
};

export default RegistrationFlow;
